import {Component} from '@angular/core';
import {UserAccessService} from "~/app/core/services/user-access.services";
import {UserAdmin} from "~/app/core/reports/models/user-admin";
import {UserService} from "~/app/core/services/user.service";
import {UserAdminStore} from "~/app/core/reports/models/user-admin-store";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-store-access',
  templateUrl: './store-access.component.html',
  styleUrls: ['./store-access.component.scss']
})

export class StoreAccessComponent {
  firstLabelName='User';
  username: string;
  selectedHoId: string;

  currentAssigned: UserAdmin[];
  currentAvailable: UserAdmin[];
  userData: UserAdmin[];
  userIds: string[];
  storeData: UserAdminStore[];
  assignedList: UserAdminStore[] = [];
  availableList: UserAdminStore[] = [];
  finalUpdateList: UserAdminStore[] = [];
  private _tempUsers: string[];
  private _tempHoId: number;
  private _userSelectedValue: string;
  private _name: string;


  constructor(public loadingIndicator: LoadingIndicatorHelper,
              public userAccessService: UserAccessService,
              private _userService: UserService) {
  }

  async ngOnInit() {
    this.username = this._userService.getUserName().toUpperCase();
    this.selectedHoId = this.userAccessService.getSelectedHoId();

    this.userData = await this.userAccessService.getUsers(this.username);
    this.userIds = await this.getUserIds(this.userData);
    this.loadingIndicator.hide();
  }

  getUserIds(usersList: UserAdmin[]): string[] {
    this._tempUsers = [];
    this._tempHoId = Number(this.selectedHoId);

    usersList.forEach((item) => {
      if (item.hoId === this._tempHoId)
        this._tempUsers.push(item.userId);
    })
    return this._tempUsers;
  }

  async userSelectorValue(results): Promise<void>{
    this.availableList = [];
    this.assignedList = [];
    this._userSelectedValue = results;

    if(this._userSelectedValue !== 'USER' && this._userSelectedValue !== undefined) {
      this.getUsersStoreList(this.selectedHoId, this._userSelectedValue).then(r => {
      });
    }
  }

  async getUsersStoreList(hoId: string, username: string): Promise<void> {
    this.storeData = await this.userAccessService.getUserStores(hoId, username);

    //call get assigned stores
    await this.getAssignedStoreList(this.storeData);
  }

  getAssignedStoreList(userStoreList: UserAdminStore[]) {
    userStoreList.forEach((item) => {
      this._name = item.chainID + ' - ' + item.storeID;
      item.name = this._name;
      if(item.storeAlias === "Assigned"){
        this.assignedList.push(item);
      } else {
        this.availableList.push(item);
      }
    });
  }
  async pickListFormResults(e): Promise<void> {
    this.loadingIndicator.show();
    // e is only assigned values
      e.forEach((store, index) => {
        this.finalUpdateList.push(store);
        if(store.storeAlias === "NotAssigned") {
          this.finalUpdateList[index].storeAlias = "Assigned";
          this.finalUpdateList[index].userID = this._userSelectedValue;
        }
      });

      // update API
      await this.userAccessService.updateStores(Number(this.selectedHoId), this._userSelectedValue, this.username, this.finalUpdateList)
        .then(response => {
          if(response === 0) {
            this._userService.showNotification('User updated Successfully',2000);
            this.loadingIndicator.hide();
          }
        }).catch((error) => {
          this._userService.showError('Problem updating user reports', 2000);
        });
        this.finalUpdateList=[];
  }

}

